import React from 'react';
import { UpdateStatus, useVersionCheck } from '../hooks/useVersionCheck';

function VersionCheck() {
  const { status, reloadPage } = useVersionCheck({ interval: 1000 * 60 * 60 }); // check for new version every hour

  if (status === UpdateStatus.checking || status === UpdateStatus.current) {
    return null;
  }

  return (
    <div className="version-notification">
      🚀 Seaber has been updated. Please <a onClick={reloadPage}>reload</a> the
      page for changes to apply.
    </div>
  );
}

export default VersionCheck;
